import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingContactsContainerLoadable } from 'shared/components/contacts_aside';
import { NewbuildingOnlineStatusContainer } from 'shared/containers/NewbuildingOnlineStatusContainer';
import { isNewbuildingFromBuilderSelector } from 'shared/selectors';
import { isPrintVersionPhoneVisibilitySelector } from 'shared/selectors/print';

import { NewbuildingMessageButtonContainer } from '../NewbuildingMessageButtonContainer';
import { PhonesContainer } from '../PhonesContainer';
import { usePhonesOpenedContext } from '../providers/PhonesOpened';

export const NewbuildingPageAsideContactsContainer = () => {
  const isNewbuildingFromDeveloper = useSelector(isNewbuildingFromBuilderSelector);
  const isPrintVersion = useSelector(isPrintVersionPhoneVisibilitySelector);
  const { isPhonesOpened } = usePhonesOpenedContext();

  return (
    <>
      {!isPrintVersion && (
        <NewbuildingContactsContainerLoadable
          contactsButton={<PhonesContainer />}
          messageButton={<NewbuildingMessageButtonContainer isPhonesOpened={isPhonesOpened} />}
          messageButtonInSeparateRow={isPhonesOpened}
        />
      )}
      {isNewbuildingFromDeveloper && <NewbuildingOnlineStatusContainer />}
    </>
  );
};
